// extracted by mini-css-extract-plugin
export default {"row":"CloudFolderRow_row__+IbtB","text":"CloudFolderRow_text__obPVE"};